<template>
  <div>
    <v-fade-transition>
      <v-overlay :value="overlay" absolute z-index="10" color="rgba(255,255,255,.2)">
        <SetupWizardStep1 v-if="step === 'welcome'" @next="next('welcome', null)" />
        <SetupWizardStep2 v-if="step === 'super-user'" :data="settings" @next="next('super-user', $event)" @cancel="closeWizard" />
        <SetupWizardStep3 v-if="step === 'mandate'" :data="settings" @next="next('mandate', $event)" @cancel="closeWizard" />
        <SetupWizardStep4 v-if="step === 'lager'" :data="settings" @next="next('lager', $event)" @cancel="closeWizard" />
        <SetupWizardStep5 v-if="step === 'admin-user'" :alert="alert" :data="settings" @save="saveWizard($event)" @cancel="closeWizard" />
      </v-overlay>
    </v-fade-transition>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
import SetupWizardStep1 from "./SetupWizardStep1.vue";
import SetupWizardStep2 from "./SetupWizardStep2.vue";
import SetupWizardStep3 from "./SetupWizardStep3.vue";
import SetupWizardStep4 from "./SetupWizardStep4.vue";
import SetupWizardStep5 from "./SetupWizardStep5.vue";
export default {
  name: "SetupWizard",
  components: {
    SetupWizardStep1,
    SetupWizardStep2,
    SetupWizardStep3,
    SetupWizardStep4,
    SetupWizardStep5,
  },
  data() {
    return {
      overlay: true,
      step: "welcome",
      steps: ["welcome", "super-user", "mandate", "lager", "admin-user"],
      alert: '',
      settings: {
        user: {
          name: "",
          email: "",
          language_id: 0,
          password: "",
          rePassword: "",
        },
        admin: {
          name: "",
          email: "",
          language_id: "",
          password: "",
          rePassword: "",
        },
        mandate: {
          name: "",
          language_id: "",
          unitSystem: "",
        },
        warehouse: {
          name: "",
        },
      },
    };
  },
  methods: {
    next(currentStep, settings) {
      if (settings) {
        this.settings = cloneDeep(settings);
      }
      this.step = this.nextStepName(currentStep);
    },
    async saveWizard(settings) {
      if (settings) {
        this.settings = cloneDeep(settings);
      }
      try {
        await this.axios.post("setupInstance", { settings });
        this.closeWizard();
      } catch (err) {
        console.error(err);
        this.alert = err.message;
      }
    },
    closeWizard() {
      this.overlay = false;
    },
    nextStepName(currentStep) {
      const nextStep = this.steps.findIndex((el) => el === currentStep);
      if (nextStep !== -1 && this.steps[nextStep + 1] !== undefined) return this.steps[nextStep + 1];
      return "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
